<template>
  <div>
    <div class="page-header">
      <span class="pull-right pointer material-icons" @click="reload()">refresh</span>
      <h3>Gmail Inbox</h3>
    </div>


    <p v-if="reloading">Loading Inbox...</p>

    <ul class="list-group">
      <p v-if="emails.length == 0 && reloading===false">No emails found.</p>
      <li class="list-group-item js-task-details-collapse-container" v-for="email in emails" :key="email.id">
        <span class="pull-right">
          <span v-if="moving">Moving...</span>
          <span v-else class="pointer material-icons" data-toggle="modal" :data-target="'#moveModal' + email.id">arrow_forward</span>
        </span>
        <span v-on:click="expandCard">
          <div><strong>{{ email.from_name }}</strong></div>
          <div>{{ email.subject }}</div>
        </span>
        <div class="collapse mt-1 mb-1 js-task-details-collapse" :id="taskDetailsCollapseId(email)">
          <span v-if="email.html_part">
            <vue-friendly-iframe :src="htmlUrl(email)" className="friendly-iframe"></vue-friendly-iframe>
          </span>
          <span v-else>
            {{  email.text_part }}
          </span>
        </div>



        <div class="modal fade" :id="'moveModal' + email.id">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Are you sure?</h5>
              </div>
              <div class="modal-body">
                <div class="mb-2">
                  The following email will be moved to the Inbox and <strong>DELETED</strong> from Gmail.
                  <br /><br />
                  <em>
                    {{email.subject}}
                  </em>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" @click="move(email)">Move Email</button>
              </div>
            </div>
          </div>
        </div>



      </li>
      <li class="list-group-item" v-if="this.next">
        <div v-if="loading">
          Loading...
        </div>
        <span v-else @click="loadInbox()" class="pointer">Load More</span>
      </li>
    </ul>
  </div>
</template>

<script>
import api from "api";

export default ({
  data() {
    return {
      emails: [],
      next: "",
      loading: false,
      reloading: true,
      moving: false
    }
  },
  created(){
    this.loadInbox()
  },
  mounted() {
    $(document).on('click touchstart', function(event) {
      if (!$(event.target).parents('.js-task-details-collapse-container').length) {
        // Hide the cards
        if(event.target.className != 'tags-input-remove' && !event.target.className.split(' ').includes('do-not-collapse')){
          $('.js-task-details-collapse').collapse('hide')
          this.expanded = false
        }
      }

      if (!$(event.target).parents('.js-new-item ').length) {
        // Hide Forms
        $('#js-todo-form').removeClass('d-block');
        $('#js-note-form').removeClass('d-block');
      }
    }.bind(this));
  },  
  methods: {
    taskDetailsCollapseId(email){
      return 'task-details-collapse-' + email.id
    },
    expandCard(event){
      this.expanded = true

      var card = $(event.target).closest('.js-task-details-collapse-container')[0]
      var collapse = $(card).find('.js-task-details-collapse')[0]
      $(collapse).collapse('show')

      if(collapse){
        $('.js-task-details-collapse').not('#' + collapse.id).collapse('hide')
      }
    },
    loadInbox() {
      var self = this
      self.loading = true
      api.getGmailInbox(this.next).then(response => {
        self.next = response.data.next_page_token
        self.emails = self.emails.concat(response.data.emails)
        self.loading = false
        self.reloading = false
      });
    },
    reload() {
      this.reloading = true
      this.emails = []
      this.next = ""
      this.loadInbox()
    },
    move(email){
      self.moving = true
      this.emails.splice(this.emails.indexOf(email), 1);
      api.moveGmailToInbox(email.id).then(response => {
        self.moving = false
        $('#moveModal' + email.id).modal('hide');
        $('body').removeClass('modal-open');
        $(".modal-backdrop").hide();
      }) 
    },
    decoded(str){
      return(atob(str))
    },
    htmlUrl(email){
      return "/api/gmail/" + email.id + "/show_html.json"
    }
  }
})
</script>
